import { useQuery } from '@apollo/client';
import { RescueCollarStatusData, RescueCollarStatusVariables, rescueCollarStatusQuery } from './RegisterChip.graphql';
import { useRegisteredChip } from './useRegisteredChip';

/**
 * Whether to ask the registrant if their rescue sent them home with the collar on their pet.
 *
 * True only when the pet still wears a rescue collar that nobody has claimed or returned. The backend
 * leaves one on the pet only when the registration asked it to defer returning it, so this stays false
 * for any registration that didn't. Network-only: claiming or returning the collar changes the answer.
 *
 * A failed read counts as nothing to ask, so a registration never stalls on this question.
 */
export function useRescueCollarStatus() {
  const { assignedPetId, loading: chipLoading } = useRegisteredChip();

  const { data, loading, error, refetch } = useQuery<RescueCollarStatusData, RescueCollarStatusVariables>(
    rescueCollarStatusQuery,
    {
      variables: { petId: assignedPetId ?? '' },
      skip: !assignedPetId,
      fetchPolicy: 'network-only',
    },
  );

  return {
    loading: chipLoading || loading,
    petId: assignedPetId,
    hasUnresolvedRescueCollar: !error && data?.pet?.hasUnresolvedRescueCollar === true,
    refetch,
  };
}
